import Entity from "../entity";
export default class Supplier extends Entity<number> {
  name: string;
  supplierType: number | string= 0;
  website: string = "";
  phoneNumber: string = "";
  introduction: string = "";
  remark: string = "";
}
